export default __webpack_public_path__ + "static/media/mail.7c62d334.svg";